export default __webpack_public_path__ + "static/media/Arrow1.f453dfea.svg";